import { connect } from 'react-redux'
import { get, compact } from 'lodash'
import { reduxForm } from 'redux-form'
import IncomingSmsForm from './IncomingSmsForm'
import showNumbersNewServiceModal from 'features/Numbers/NumbersNewServiceModal'
import { mobileServices } from 'features/Numbers/Numbers.utils'

const stateToProps = ({ form, numbers }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  numberOptions: mobileServices(numbers).map(number => ({
    name: compact([number.number, number.customerReference]).join(' - '),
    number: number.number,
    value: number.id,
  })),
})

const dispatchToProps = {
  showNumbersNewServiceModal,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(IncomingSmsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingSms/IncomingSmsForm.container.js